import { memo } from "react";
import { Navigate } from "react-router-dom";
import { PAYOUT_CLAIM_ROUTES } from "../../constants";

/** Live payout-claim has no deposit CTA; the old launcher goes to the list. */
export const CashDepositPage = memo(() => (
  <Navigate to={PAYOUT_CLAIM_ROUTES.TRANSACTIONS} replace />
));
